import { useHasPermission } from "../../auth/useClaims";

// Guard Assignments (the Customer detail screen's tab + standalone Bulk
// Guards screen) split off from Customers.Edit into their own permission
// (handoff §13.4, shipped same day as §13.3) - a CRM/sales role that can
// edit a customer's own contact/address fields shouldn't necessarily be
// able to deploy guards, and vice versa. Covers all three write endpoints
// (replace rows, activate/deactivate status, bulk-create) - bulk-create was
// deliberately not split into its own permission, same Guards.Edit as
// everything else on this screen. No all-branch check needed, same as
// Customers.Edit - the API already scopes by the caller's own branch(es).
export const useCanEditGuardAssignments = () => useHasPermission("Guards.Edit");
